import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import {ProductBasedLogo,} from "../../assets";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";

const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });
  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    const resetToken = obj.get('reset_password_token');
    if (resetToken)
        setResetToken(obj.get('reset_password_token') || '');
    else
        navigate('/users/sign_in');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate('/users/sign_in');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string , confirmPassword: string}) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

    return (
        <div className="login-sec mt-0 mt-sm-0 mt-md-0 d-flex flex-fill flex-column overflow-auto justify-content-center">
            <div className="row justify-content-center align-items-center">
                <div className="col-12 col-md-5">
                    <form onSubmit={handleSubmit(submitPassword)}>
                        <h2 className="mb-3">Reset Password</h2>
                        <div className="mb-3">
                            <Controller
                                name="password"
                                control={control}
                                defaultValue=''
                                render={({field, fieldState: {error}}) => (
                                    <HubInputField
                                        inputId="password"
                                        isRowBased={false}
                                        isRequired={true}
                                        field={field}
                                        error={error}
                                        inputLabel="New Password"
                                        inputType="password"
                                    />
                                )}
                            />
                        </div>
                        <div className="mb-4">
                            <Controller
                                name="confirmPassword"
                                control={control}
                                defaultValue=''
                                render={({field, fieldState: {error}}) => (
                                    <HubInputField
                                        inputId="confirmPassword"
                                        isRowBased={false}
                                        isRequired={true}
                                        field={field}
                                        error={error}
                                        inputLabel="Re-Enter Password"
                                        inputType="password"
                                    />
                                )}
                            />
                        </div>

                        <div className="row align-items-center">
                            <div className="col-auto">
                                <button disabled={loading} className="btn btn-warning btn-lg" type="submit">
                                    <div className="row align-items-center px-1">
                                        {loading ? (
                                            <div className="spinner-border text-light col-3" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        ) : null}
                                        <p className="col-auto mb-0"> Reset Password </p>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </form>

                    <div className="mt-3 d-flex justify-content-end">
                        <img src={ProductBasedLogo} height="80" alt="Product Logo"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HubResetPassword;
